// extracted by mini-css-extract-plugin
export default {"div":"Education_div__dHQHz","h1":"Education_h1__oh8A-","h2":"Education_h2__Y50XN","h3":"Education_h3__VvNnE","card":"Education_card__n+YfE"};